import AddEditSpeaker from 'components/Shared/AddEditSpeaker';
import ConfirmModal from "components/Shared/ConfirmModal";
import config from "constants/config";
import httpClientV1 from 'http-common-v1';
import { useEffect, useState } from "react";
import Pagination from 'react-bootstrap/Pagination';
import toast from "react-hot-toast";


import {
    Button, Card, Col, Container, Dropdown, Form, Row, Table
} from "react-bootstrap";

function V1Speakers() {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10)
    const [item, setItem] = useState([])
    const [name, setName] = useState(null)
    const [targetLang, setTargetLang] = useState(null)
    const [targetLangText, setTargetLangText] = useState(null);
    const [type, setType] = useState(1);
    const [selectItemValue, setSelectItemValue] = useState(null)
    const [message, setMessage] = useState('');
    const [modalConfirmShow, setModalConfirmShow] = useState(false);


    const [voices, setVoices] = useState([]);
    const [totalVoiceCount, setVoiceCount] = useState(0)
    const [sourceLang, setSourceLang] = useState(config.LANGUAGES_ASSENTS_SOURCE)
    const [modalShow, setModalShow] = useState(false);

    let isShow = false;
    let numberOfPages = 0;

    useEffect(() => {
        getAllVoices('', 0);
    }, []);


    const getAllVoices = async (value) => {


        try {
            let url = config.V1_VIDEO_API_URL + `/voice/all?page=${(value != "") ? value : page}&limit=${limit}&`
            if (name != null) {
                url = url + 'name=' + name
            }
            if (targetLang != null) {
                url = url + '&targetLanguage=' + targetLang

            }
            const getAllVoice = await httpClientV1.get(url)
            const responseData = getAllVoice.data.data;
            setVoiceCount(responseData.totalVoice);
            const activeValue = (value != "") ? value : page;
            mapPagination(responseData.totalVoice, activeValue)
            setVoices(responseData.voices);
            isShow = true;
        } catch (error) {
            console.log(error)
        }

    }

    const getApiCallPage = async (value) => {
        await setPage(value);
        await getAllVoices(value);
    }

    const mapPagination = (totalCount, active) => {
        numberOfPages = Math.ceil(totalCount / limit);
        let items = []
        for (let number = 1; number <= numberOfPages; number++) {
            items.push(
                <Pagination.Item key={number} active={number === active} onClick={() => getApiCallPage(number)}>
                    {number}
                </Pagination.Item>,
            );
        }
        setItem(items);
    }

    return (
        <>
            <Container fluid>
                <Row >
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover table-c">
                            <Card.Header>
                                <Row className="table-header-top">
                                    <Card.Title as="h4" className="card_title">Videos list</Card.Title>
                                    <Col xs={5}>
                                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                            <Form.Control value={name} onChange={(v) => {
                                                setName(v.target.value)
                                            }}
                                                type="text" placeholder="search by title" />
                                        </Form.Group>

                                    </Col>

                                    <Col >
                                        <Dropdown className="d-inline mx-2">
                                            <Dropdown.Toggle id="dropdown-basic-button">
                                                {targetLangText != null ? targetLangText : "Source Lang"}
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {sourceLang.length > 0 && sourceLang.map((v, index) => {
                                                    return (<Dropdown.Item onClick={() => {
                                                        setTargetLangText(v.text)
                                                        setTargetLang(v.value)
                                                    }} >{v.text}</Dropdown.Item>)
                                                })
                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </Col>

                                    <Col>
                                        <Button variant="primary" className="cart_title_button custom_margin" onClick={(v) => getApiCallPage(1)} >Submit</Button>
                                        <Button variant="primary" className="cart_title_button" onClick={() => {
                                            setSelectItemValue(null)
                                            setType(1);
                                            setModalShow(true)
                                        }} >Add Voice</Button>
                                    </Col>

                                </Row>

                            </Card.Header>
                            <Card.Body className="table_video table-full-width table-responsive px-0">
                                <Table className="table-hover table-striped">
                                    <thead>
                                        <tr>
                                            <th className="border-0">No</th>
                                            <th className="border-0">Name</th>
                                            <th className="border-0">Gender</th>
                                            <th className="border-0">Accent Language</th>
                                            <th className="border-0">Voice Id</th>
                                            <th className="border-0">Source Type</th>
                                            <th className="border-0">Model Type</th>
                                            <th className="border-0">Status</th>
                                            <th className="border-0">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {voices.length > 0 &&
                                            voices.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{(index + 1)}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.gender}</td>
                                                        <td>{item.accentCode}</td>
                                                        <td>{item.voiceId}</td>
                                                        <td>{item.sources}</td>
                                                        <td>{item.modelDetail}</td>

                                                        <td>{item.isActive ? "Enabled" : "Disabled"}</td>

                                                        <td>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="info" id="dropdown-basic">
                                                                    Action
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => {
                                                                        setSelectItemValue(item)
                                                                        setType(2);
                                                                        setModalShow(true)
                                                                    }}
                                                                    >Update</Dropdown.Item>
                                                                    <Dropdown.Item
                                                                        onClick={() => {
                                                                            setMessage("Are you sure?. Want to delete voice:- " + item.name)
                                                                            setSelectItemValue(item)
                                                                            setModalConfirmShow(true)
                                                                        }}
                                                                    >Remove</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>

                                                        </td>

                                                    </tr>)

                                            })
                                        }

                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {item && <Row className="paginationValue">
                    <Pagination>{item}</Pagination>
                </Row>}



            </Container>


            {modalShow && <AddEditSpeaker type={type} show={modalShow} itemData={selectItemValue} onHide={async () => {
                getApiCallPage(1)
                setModalShow(false);

            }}
            ></AddEditSpeaker>}

            <ConfirmModal message={message} setMessage={setMessage} show={modalConfirmShow} onHide={async (number) => {
                if (number === 1) {
                    try {
                        const getAllVoice = await httpClientV1.delete(`${config.V1_VIDEO_API_URL}/voice/${selectItemValue.uuid}`);
                        toast.success("Voice Update successfully");
                    } catch (error) {
                        toast.success(error?.message);
                    }
                    getApiCallPage(1);
                    setSelectItemValue(null)
                    setModalConfirmShow(false);

                } else {
                    setSelectItemValue(null)
                    setModalConfirmShow(false);
                }

            }}
            ></ConfirmModal>

        </>

    )


}

export default V1Speakers;